import { Children, ReactNode, useCallback } from 'react';

export const useChildByDisplayName = (children: ReactNode) => useCallback((displayName: string) => {
  return Children.map(children, (child => {
    if (!child) {
      return null;
    }
    // @ts-ignore
    if (child?.type?.displayName === displayName) {
      return child;
    }
    return null;
  })) as ReactNode[];
}, [ children ]);
